import compareDesc from 'date-fns/compareDesc';
import CustomDnbCalendar from './assets/icons/CustomDnbCalendar';
import CustomDnbStatus from './assets/icons/CustomDnbStatus';
import exclamation_triangle from '@dnb/eufemia/icons/exclamation_triangle';
import exclamation_medium from '@dnb/eufemia/icons/exclamation_medium';
import stop from '@dnb/eufemia/icons/stop';
import { account_card_medium, account_medium, cog_medium, log_in_medium, mobilephone, savings_account_medium, wallet_medium} from '@dnb/eufemia/icons';
import { check_medium } from '@dnb/eufemia/icons';

export function getIcon(icon) {
  switch (icon) {
    case 'Andre tjenester privat':
    case 'Other services personal':
    case 'Andre tjenester business':
    case 'Other services business':
    case 'Andre tjenester bedrift':
      return account_medium;
    case 'wallet':
    case 'Nettbank':
    case 'Corporate Internet banking':
      return wallet_medium;
    case 'credit-card':
    case 'Minibanker, kort og betalingsterminaler':
    case 'Minibanker, Kort Og Betalingsterminaler':
      return account_card_medium;
    case 'log-in':
    case 'Innlogging':
    case 'Login':
      return log_in_medium;
    case 'calendar':
      return CustomDnbCalendar;
    case 'status':
      return CustomDnbStatus;
    case 'mobile-bank':
    case 'Mobilbank':
    case 'DNB Bedrift':
    case 'Sbanken Mobilbank':
      return mobilephone;
    case 'Spare':
    case 'Savings':
      return savings_account_medium;
    // case 'DNB Bedrift':  
      // return bank_medium;
    default:
      return null;
  }
}

export function getIncidentStatus(status) {
  switch (status) {
    case 'operational':
      return 'ok';
    case 'partial_outage':
      return 'partial';
    case 'degraded_performance':
      return 'partial';
    case 'major_outage':
      return 'down';
    case 'under_maintenance':
      return 'partial';
    default:
      break;
  }
}




// TODO Sette et fornuftig default ikon
export function getStatusColor(status) {
  console.log("getStatusColor", status);
  switch (status) {
    case 'operational':
    case 'none':
      return 'sea-green';
    case 'degraded_performance':
      return 'accent-yellow';
    case 'major':
    case 'major_outage':
    case 'critical':  
    case 'minor':
    case 'minor_outage':
    case 'partial_outage':
      return 'accent-red';
    default:
      return 'sea-green';
  }
}


// TODO Sette et fornuftig default ikon
export function getStatusIcon(status) {
  switch (status) {
    case 'operational':
    case 'none':
      return check_medium;
    case 'minor':
    case 'minor_outage':
    case 'partial_outage':
      return exclamation_triangle;
    case 'degraded_performance':  
      return exclamation_medium;
    case 'major':
    case 'major_outage':
    case 'critical':
      return stop;
    case 'under_maintenance':
      return cog_medium;

    default:
      return check_medium;
  }
}

/* Function to get incident status icon for IncidentViewer component 
   Returns icon based on four status types: operational, minor outage, major outage, degraded performance */
export function getIncidentStatusIcon(status) {
  switch (status) {
    case 'operational':
    case 'none':
      return check_medium;
    case 'minor_outage':
    case 'partial_outage':
    case 'minor':  
      return exclamation_triangle;
    case 'major_outage':
    case 'critical':
    case 'major':
      return stop;
    case 'degraded_performance':
      return exclamation_medium;
    default:
      return check_medium;
  }
}

/* Helper function that merges a groups incidents and its sub-components incidents. Returns an array of all incidents */
export function mergeIncidents(item) {
  let arr = [];
  for (let sub of item.subComponents) {
    for (let incident of sub.incidents) {
      arr.push(incident);
    }
  }

  let allIncidents = [...item.incidents, ...arr].sort((a, b) => {
    return compareDesc(new Date(a.created_at), new Date(b.created_at));
  });

  return allIncidents;
}

export function addIncidentsToGroup(groups, incidents) {
  let groupsCopy = [...groups];
  /* Iterate through all incidents, we need to attach them to the correct component */
  for (let incident of incidents) {
    for (let component of incident.components) {
      let correctGroup;

      correctGroup = groupsCopy.find((e) => e.id === component.id);

      if (correctGroup) {
        correctGroup.incidents.push(incident);
      } else {
        /* If incident is not in one of our groups, check subgroups/components, and push to correct one */
        for (let group of groupsCopy) {
          let found = group.subComponents.find((el) => el.id === component.id);
          if (found) {
            if (!group.incidents.some((e) => e.id === incident.id)) {
              group.incidents.push(incident);
            }
          }
        }
      }
    }
  }
  return groupsCopy;
}

export function isBankIDIncident(incident) {
  return incident.name.toLowerCase().includes('bankid');
}

// To handle tab routing
export function extractFirstPartOfPath(path) {
  return '/' + path.split('/')[1];
}